<template>
  <div class="content-our-brands-content" id="identidade-verbal-conteudo-nossas-marcas" data-search-anchor>
    <div class="content-our-brands-wrapper">
      <h1 class="content-our-brands-title">{{ contentOurBrandsTitle }}</h1>
    </div>
    <div class="content-our-brands-description-wrapper">
      <div class="content-our-brands-icon-wrapper-sec">
        <IconCheck />
        <p class="content-our-brands-description-icon">{{ contentOurBrandsDescription }}</p>
      </div>


      <div class="icon-wrapper">
        <IconCheck />
        <p class="content-our-brands-description-icon1">{{ contentOurBrandsDescription1 }}</p>
      </div>
    </div>
    <div class="content-our-brands-card-item" :style="{ backgroundImage: `url(${contentOurBrandsImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from '@/mixins/content-page-mixin'
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class ContentOurBrandsSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)

  get contentOurBrandsTitle(): string {
    return this.getElementTitle(2, 0)
  }

  get contentOurBrandsDescription(): string {
    return this.getElementText(2, 1)
  }

  get contentOurBrandsDescription1(): string {
    return this.getElementText(2, 2)
  }

  get contentOurBrandsImageSrc(): string {
    return this.getElementMedia(2, 3)
  }

  async getContentPage(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPage()
    }
  }
}
</script>

<style lang="scss">
.content-our-brands-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.content-our-brands-wrapper {
  display: block;
  align-items: center;
  padding-top: 85px;
  padding-bottom: 50px;
}

.content-our-brands-title {
  font-size: 56px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
}

.content-our-brands-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-top: 0px;
}

.content-our-brands-description-wrapper {
  position: relative;
  grid-template-columns: 56% 50%;
  margin-bottom: 50px;

}
.content-our-brands-icon-wrapper-sec {
  display: flex;
  
}

.content-our-brands-description-icon {
  font-size: 16px;
  margin-top: 0;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  padding-left: 7px;
  white-space: pre;
}

.content-our-brands-description-icon1 {
  padding-left: 7px;
}

.content-our-brands-card-item {
  position: relative;
  width: 1032px;
  height: 649px;
  border-radius: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.icon-wrapper {
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}
</style>
